<template>
    <div class="pro_box">
        <div class="tbs_box">

            <div class="position_box">
                <div class="title_box">
                    职位类型
                </div>
                <div class="item_flex">
                    <div   
                        @click="clickposi(item)"
                        :class="posiactive==item.id?'posiac':''" 
                        class="posi_item_box" 
                        v-for="(item,index) of position" 
                        :key="index">
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="location_box">
                <div class="title_box">
                    工作地点
                </div>
                <div class="item_flex">
                    <div
                        @click="clickload(item)"
                        :class="loadactive==item.id?'loacac':''" 
                        class="posi_item_box" 
                        v-for="(item,index) of location" 
                        :key="index">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>    
        <div class="content_box">
            <el-table 
                ref="table"  
                :header-cell-style="headCellStyle"
                highlight-current-row
                @row-click="rowClick"
                row-key="id"
                :cell-style="cellstyle"
                :cell-class-name="tableCellClassName"
                :data="tableData" >
                <el-table-column
                    label="职位"
                    width="280"
                    prop="name">
                </el-table-column>
                <el-table-column
                    label="职位类型"
                    prop="type">
                </el-table-column>
                <el-table-column
                    label="职位性质"
                    prop="nature">
                </el-table-column>
                <el-table-column
                    label="学历要求"
                    prop="education">
                </el-table-column>
                <el-table-column
                    label="工作城市"
                    show-overflow-tooltip
                    prop="city">
                </el-table-column>
                <el-table-column
                    label="工作年限"
                    prop="years">
                </el-table-column>
                <el-table-column
                    label="发布时间"
                    prop="now">
                </el-table-column>
                <el-table-column
                    align="center">
                    <template slot-scope="scoped" >
                        <i v-if="scoped.row.state==false" class="el-icon-arrow-down"></i>
                        <i v-else class="el-icon-arrow-up" ></i>
                    </template>
                </el-table-column>
                <el-table-column type="expand" width="1" class="html_details">
                    <template slot-scope="props">
                        <div class="expand_font" v-html="props.row.info"></div>
                        <el-button class="app_button" @click="dialogVisible=true">申请</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="prompt_box">
                <div class="font_title">申请岗位请将个人简历发送至</div>
                <div class="email">service@xzjxrl.com</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default{
    data(){
        return{
            position:[],
            posiactive:null,
            location:[],
            loadactive:null,
            tab:[],
            dialogVisible:false,
            tableData: [],
             currentExpandedRow: null
            
        }
    },
    async created(){
        this.tabsaxios()
       
    },
    mounted(){
       
    },
    methods:{
        tabsaxios(){
            this.$webhttp.get('v1/web/dictionary').then((res)=>{
                if(res.code==200){
                    res.data.forEach((item)=>{
                        if(item.type==1){
                            this.position.push(item)
                        }
                        if(item.type==4){
                            this.location.push(item)
                        }
                    }) 
                    this.position.unshift({id:0,name:'全部'})
                    this.location.unshift({id:0,name:'全部'})
                    this.loadactive=this.location[0].id
                    this.posiactive=this.position[0].id 
                    this.tableaxios(this.posiactive,this.loadactive)
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        tableaxios(type,cityId){
            this.$webhttp.get(`v1/web/hire?type=${type}&cityId=${cityId}`).then((res)=>{
                if(res.code==200){
                    res.data.forEach((item,index,array)=>{
                        array[index].info=item.info.replace(/\n/g,'<br/>')
                        array[index]['state']=false
                    })
                    this.tableData=res.data
                }else{
                    this.$message.error(res.message)
                }   
            })  
                    
        },
          headCellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 && rowIndex === 0) {
                return `padding-left:30px;background:rgba(2,125,252,0.1);color:#101010;font-weight:800`;
            } else {
                return `background:rgba(2,125,252,0.1);color:#101010;font-weight:800`
            }
        },
        cellstyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                return `padding-left:30px;`;
            } else {
                return ''
            }
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
         
            if (columnIndex == 0) {
                return 'cell-start'
            } else if (columnIndex == 8) {
                return 'cell-end'
            } else {
                return 'cell-middle'
            }
        },
        clickposi(item){
            this.posiactive=item.id
            this.tableaxios(this.posiactive,this.loadactive)
        },
        clickload(item){
            this.loadactive=item.id
            this.tableaxios(this.posiactive,this.loadactive)
        
        },
     
        rowClick(row,column,event) {
            this.switchicon(row)
            this.toogleExpand(row)
          
        },
        switchicon(row,column,event){
            this.tableData.forEach((item,index,array)=>{
                if(row.id==item.id){
                    array[index].state=!item.state
                }else{
                    array[index].state=false
                }
            })
        },
        toogleExpand(row,column,event) {
            // let $table = this.$refs.table;
            // this.tableData.forEach((item) => {
            //     if (row.id != item.id) {
            //         $table.toggleRowExpansion(item, false)
            //     }
            // })
            // $table.toggleRowExpansion(row)
                 if (this.currentExpandedRow === row) {
                    row.expanded = false
                    this.$refs.table.toggleRowExpansion(row, false)
                    this.currentExpandedRow = null
                } else {
                    if (this.currentExpandedRow) {
                    this.currentExpandedRow.expanded = false
                    this.$refs.table.toggleRowExpansion(this.currentExpandedRow, false)
                    }
                    this.$nextTick(() => {
                    row.expanded = true
                    this.$refs.table.toggleRowExpansion(row, true)
                    this.currentExpandedRow = row
                    })
                }
        },
      
    },
}
</script>
<style lang="less" scoped>

/deep/.highlight {
  background:rgba(2,125,252,0.1);
    color: #101010 !important;
    box-sizing: border-box;
}
/deep/ .el-table__body tr.current-row > td {
    background:rgba(2,125,252,0.1);
    color: #101010 !important;
    box-sizing: border-box;

}

/deep/.el-table::before{
    height: 0px;
}
/deep/.el-table tr{
    color: #101010 !important;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 5px;
    box-sizing: border-box;
}
/deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: none;    
}
/deep/.cell-start {
    box-sizing: border-box;
    border-top: 1px solid #D5D5D5 ;
    border-bottom: 1px solid #D5D5D5  !important;
    border-left: 1px solid #D5D5D5 ;
}
/deep/.cell-end {
    box-sizing: border-box;
    border-top: 1px solid #D5D5D5 ;
    border-bottom: 1px solid #D5D5D5  !important;
    border-right: 1px solid #D5D5D5 ;
    border-left: 1px solid #D5D5D5 ;
}
/deep/.cell-middle {
    box-sizing: border-box;
    border-top: 1px solid #D5D5D5 ;
    border-bottom: 1px solid #D5D5D5  !important;
}
/deep/.el-table__body {  //这行代码为间隔效果！！！
    border-spacing: 0px 2px !important;
    box-sizing: border-box;
}
/deep/.el-table td {
    height: 56px;
    box-sizing: border-box;
}
/deep/.el-table__cell{
    .el-icon-arrow-down,.el-icon-arrow-up{
        font-weight: bold;
        width: 30px;
        height: 20px;
        line-height: 20px;
        cursor: pointer;
    }
}
/deep/.el-table__expanded-cell{
    box-sizing: border-box;
    padding: 0px 39px;
    .expand_font{
        margin-top: 5px;
    }
    .app_button{
        width: 96px;
        height: 32px;
        background: #027DFC;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        padding: 0px 0px;
        margin-bottom: 22px;
        margin-top: 10px;
    }
}

.prompt_box{
    box-sizing: border-box;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .font_title{
        font-size: 18px;
        box-sizing: border-box;
        margin-bottom: 10px;
        font-weight: bold;
    }
    .email{
        font-weight: bold;
        font-size: 22px;
        color: #101010;
    }
}
.pro_box{
    width: 100%;
    padding: 0px 160px;
    box-sizing: border-box;
    display: flex;
    .content_box{
        width: 86%;
        min-height: 650px;
        padding-top: 40px;
        padding-left: 92px;
        box-sizing: border-box;
        user-select: none;
        margin-bottom: 40px;
    }
   .tbs_box{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        width: 208px;
        user-select: none;
        .location_box{
             margin-bottom: 32px;
            .title_box{
                font-weight: 500;
                font-size: 16px;
                color: #606060;
                line-height: 40px;
            }
            .item_flex{
                display: flex;    
                flex-wrap: wrap;
                .loacac{
                    background: #027DFC !important;
                    color: #FFFFFF !important;
                }
                .posi_item_box:hover{
                    background: #027DFC;
                    color: #FFFFFF;
                }
                .posi_item_box{
                    width: 96px;
                    height: 32px;
                    background: #FFFFFF;
                    border: 1px solid #D5D5D5;
                    text-align: center;
                    line-height: 32px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #606060;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    box-sizing: border-box;
                    cursor: pointer;
                }
            }
        }
        .position_box{
            margin-bottom: 32px;
            .title_box{
                font-weight: 500;
                font-size: 16px;
                color: #606060;
                line-height: 40px;
            }
            .item_flex{
                display: flex;    
                flex-wrap: wrap;
                .posiac{
                    background: #027DFC !important;
                    color: #FFFFFF !important;
                }
                .posi_item_box:hover{
                    background: #027DFC;
                    color: #FFFFFF;
                }
                .posi_item_box{
                    width: 96px;
                    height: 32px;
                    background: #FFFFFF;
                    border: 1px solid #D5D5D5;
                    text-align: center;
                    line-height: 32px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #606060;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    box-sizing: border-box;
                    cursor: pointer;
                }
            }
        }
        .tab_item:hover{
            background: #027DFC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;

        }
        .cactive{
            background: #027DFC !important;
            color: #FFFFFF !important;
        }
        .tab_item{
            border: 1px solid #ECECEC;
            background: #FFFFFF;
            height: 40px;
            width: 200px;
            text-align: center;
            line-height: 40px;
            box-sizing: border-box;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #606060;
            line-height: 40px;
        }
    }
}
</style>